export const GOOGLE = 'google';
export const BING = 'bing';
export const supportedProviders = [GOOGLE, BING];

export function isSupportedProvider(provider) {
  return supportedProviders.indexOf(provider) !== -1;
}
